
import { defineComponent, onMounted, ref } from "vue";
export default {
  setup() {
    localStorage.clear();
  },

  mounted() {
    localStorage.clear();
  },
};
